import React from "react";
import {
  UtensilsCrossed,
  BookOpen,
  Stethoscope,
  Target,
  Shirt,
  Home,
  TrendingUp,
  Users,
} from "lucide-react";
import { Link } from "react-router-dom";

const Mission = () => {
  const missionActivities = [
    {
      id: 1,
      name: "খাদ্য",
      description: "আমরা চাই যাতে কোন মানুষ খাদ্য অভাবে না থাকে।",
      icon: <UtensilsCrossed className="h-16 w-16 text-white" />,
    },
    {
      id: 2,
      name: "শিক্ষা",
      description: "শিশুদের শিক্ষা থেকে ঝড়িয়ে পড়া রোধ করতে চাই আমরা।",
      icon: <BookOpen className="h-16 w-16 text-white" />,
    },
    {
      id: 3,
      name: "চিকিৎসা",
      description:
        "চিকিৎসার অভাবে যাতে কাউকে মরতে না হয় সেই প্রচেষ্টায় কাজ করছি আমরা।",
      icon: <Stethoscope className="h-16 w-16 text-white" />,
    },
    {
      id: 4,
      name: "বস্ত্র",
      description:
        "প্রয়োজনীয় পোশাক-আশাক প্রদানের মাধ্যমে মানুষের মৌলিক চাহিদা পূরণ করি।",
      icon: <Shirt className="h-16 w-16 text-white" />,
    },
    {
      id: 5,
      name: "বাসস্থান",
      description:
        "নিরাপদ আশ্রয়ের ব্যবস্থা করে মানুষের বাসস্থানের সমস্যা সমাধানে কাজ করি।",
      icon: <Home className="h-16 w-16 text-white" />,
    },
    {
      id: 6,
      name: "সাবলম্বীকরণ",
      description:
        "মানুষকে স্বাবলম্বী করে তোলার জন্য দক্ষতা উন্নয়ন ও কর্মসংস্থানে সহায়তা করি।",
      icon: <TrendingUp className="h-16 w-16 text-white" />,
    },
  ];

  return (
    <div className="max-w-6xl mx-auto px-4 mt-10 mb-16">
      {/* Header with decorative elements */}
      <div className="text-center mb-8">
        <h1 className="relative inline-block text-3xl md:text-4xl font-bold text-primary mb-2">
          <span className="absolute -left-8 top-1/2 transform -translate-y-1/2 hidden md:block">
            <Target className="h-6 w-6 text-primary/70" />
          </span>
          আমাদের লক্ষ্য এবং উদ্দেশ্য
          <span className="absolute -right-8 top-1/2 transform -translate-y-1/2 hidden md:block">
            <Target className="h-6 w-6 text-primary/70" />
          </span>
        </h1>
        <div className="h-1 w-24 bg-primary mx-auto rounded-full"></div>
      </div>

      {/* Updated Mission Statement */}
      <div className="bg-white rounded-lg shadow-lg p-6 mb-10">
        <p className="text-gray-700 leading-relaxed text-center max-w-4xl mx-auto">
          আমরা ভালবাসায়, ধনী-গরিব, অসহায় সকল শ্রেণীর মানুষদের নিয়ে একটি
          মানবিক পৃথিবীর স্বপ্ন দেখি। সমাজের নিঃস্ব, অসহায়, নিপীড়িত মানুষদের
          মৌলিক অধিকার নিশ্চিত করাই আমাদের প্রধান লক্ষ্য। যা সম্পূর্ণ অরাজনৈতিক,
          অলাভজনক, সামাজিক ও সেবামূলক চিন্তায় পরিচালিত হয়।
        </p>
      </div>

      {/* Mission Activities Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
        {missionActivities.map((activity) => (
          <div
            key={activity.id}
            data-aos="flip-up"
            className="bg-white rounded-lg shadow-lg overflow-hidden transition-transform duration-300 hover:translate-y-[-5px]"
          >
            <div className="bg-primary p-6 flex justify-center">
              {activity.icon}
            </div>
            <div className="p-6">
              <h2 className="text-xl font-bold text-gray-800 mb-2 text-center">
                {activity.name}
              </h2>
              <p className="text-gray-700 text-center">
                {activity.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Membership Section */}
      <div className="bg-gradient-to-r from-primary to-primary/80 rounded-xl shadow-xl p-8 text-white text-center">
        <div className="mb-6">
          <Users className="h-16 w-16 mx-auto mb-4 text-white/90" />
          <h2 className="text-2xl md:text-3xl font-bold mb-4">
            গর্বিত সদস্য হউন
          </h2>
        </div>
        <p className="text-lg leading-relaxed max-w-4xl mx-auto mb-6">
          আপনি কি NNS এর একজন গর্বিত সদস্য হতে ইচ্ছুক? আপনি আমাদের সাথে
          নিঃস্বার্থ মনন লালনের মাধ্যমে আপনার সময়, দক্ষতা এবং জ্ঞান অবদান রাখতে
          পারেন। এটি একটি ইতিবাচক প্রভাব তৈরি করার সুযোগ এবং আত্মতৃপ্তি, শান্তি
          ও উন্নয়ন অর্জনের জন্য একটি গুরুত্বপূর্ণ শক্তি যা অনেকের জীবনে একটা
          পার্থক্য গড়ে তুলুন!
        </p>
        <Link
          to="/register"
          className="bg-white text-primary px-8 py-3 rounded-full font-semibold text-lg hover:bg-gray-100 transition-colors duration-300 shadow-lg"
        >
          যোগদান করুন
        </Link>
      </div>
    </div>
  );
};

export default Mission;
